/* import __COLOCATED_TEMPLATE__ from './secure-messenger.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import { type InstallationPlatformStatus } from 'embercom/components/installation-new/installation-platform-selector';
import { type PulseAccordion } from 'glint/pulse';
import { INSTALLATION_STATUS } from './constants';

interface Args {
  accordion: PulseAccordion;
  platform: 'web' | 'mobile';
  installationStatuses: InstallationPlatformStatus[];
}

interface Signature {
  Args: Args;
  Element: any;
}

export default class SecureMessenger extends Component<Signature> {
  @service declare appService: AppService;
  @service declare router: RouterService;

  get hasConversationTtl() {
    return this.appService.app.canUseFeature('conversation-ttl-unsecured-messenger');
  }

  get securelyInstalled() {
    return this.args.installationStatuses.any(
      (installation) => installation.status === INSTALLATION_STATUS.SECURELY_INSTALLED,
    );
  }

  @action openJwtSecurity() {
    safeWindowOpen(this.router.urlFor('apps.app.settings.channels.messenger.security'), '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::SecureMessenger': typeof SecureMessenger;
    'installation-new/secure-messenger': typeof SecureMessenger;
  }
}
